import { httpInterceptors } from "./interceptors";

export async function request(uri: string, options: RequestInit): Promise<Response> {
  if (!options.headers) {
    options.headers = {};
  }
  if (!options.headers!["Accept"]) {
    options.headers!["Accept"] = "*/*";
  }
  if (!Object.keys(options.headers!).some(k => k.toLowerCase() === "content-type")) {
    options.headers!["Content-type"] = "application/json";
  } else if (options.headers!["Content-type"] === '') {
    delete options.headers["Content-type"];
  }

  for (const interceptor of httpInterceptors.requestInterceptors) {
    options = await interceptor(options);
  }
  let response = await fetch(uri, options);
  for (const interceptor of httpInterceptors.responseInterceptors) {
    response = await interceptor(response);
  }
  return response;
}
